import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { FormularioEquipoComponent } from './formulario-equipo/formulario-equipo.component';
import { EquipoModel } from '@/store/catalogos/equipo';
import { EquipoService } from '@services/catalogo/equipo.service';
import { FormularioCodigoEquipoCaracteristicaComponent } from '../codigo-equipo/formulario-codigo-equipo-caracteristica/formulario-codigo-equipo-caracteristica.component';
import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-equipo',
  templateUrl: './equipo.component.html',
  styleUrls: ['./equipo.component.scss']
})
export class EquipoComponent {
  PROP = properties;
  displayedColumns: string[] = ['claveInterna', 'nombre', 'modelo', 'serie', 'options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private equipoService: EquipoService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.loadEquipo();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadEquipo() {
    this.equipoService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: true, update: false, view: false, row: null }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }

  update(row: EquipoModel) {
    const dialogRef = this.dialog.open(FormularioEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: false, update: true, view: false, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }

  view(row: EquipoModel) {
    const dialogRef = this.dialog.open(FormularioEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: false, update: false, view: true, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }

  settings(row: CodigoEquipoModel) {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoCaracteristicaComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: true, update: false, view: false, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }
}
